<template>
  <div class="modal__content">
    <form>
      <div class="form-row" v-if="args.userRole !== 'customer'">
        <label for="existing-user">Select existing user</label>
        <select name="existing-user" id="existing-user" v-model="selectedUser" class="form-control">
          <option :value="null">Select User</option>
          <option v-for="option in users" :value="option.email" :key="option.id">{{option.email}}</option>
        </select>
      </div>

      <div class="form-row" v-if="!selectedUser && args.userRole !== 'customer'">
        <label for="name">First Name</label>
        <input class="form-control" type="text" name="name" id="name" v-model="project.customerFirstName"
               placeholder="Steve">
      </div>

      <div class="form-row" v-if="!selectedUser && args.userRole !== 'customer'">
        <label for="surname">Last Name</label>
        <input class="form-control" type="text" name="surname" id="surname" v-model="project.customerLastName"
               placeholder="Jobs">
      </div>

      <div class="form-row">
        <label for="company">Company</label>
        <input class="form-control" type="text" name="company" id="company" v-model="project.customerCompanyName"
               placeholder="Apple">
      </div>

      <div class="form-row" v-if="!selectedUser && args.userRole !== 'customer'">
        <label for="email">Email</label>
        <input class="form-control" type="email" name="email" id="email" v-model="project.customerEmail"
               placeholder="steve@apple.com">
      </div>

      <div class="form-row" v-if="!selectedUser && args.userRole !== 'customer'">
        <label for="password">Password</label>
        <input class="form-control" type="password" name="password" id="password"
               v-model="project.customerPasswordPlainText" placeholder="Password">
      </div>

      <div class="flex flex--justify-center mt20">
        <button class="btn btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">Close</button>
        <button class="btn" type="submit" :disabled="disabledSubmit" @click.prevent="onProjectCreate">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
  import sha256 from 'sha256'
  import { apiCreateProject, apiGetListCustomers } from '@/api/project.api'
  import { errorMessage } from 'modules/Error'

  export default {
    data () {
      return {
        project: {
          customerFirstName: null,
          customerLastName: null,
          customerEmail: null,
          customerCompanyName: null,
          customerPasswordPlainText: null,
          isExistingCustomer: true
        },
        user: null,
        users: null,
        selectedUser: null,
        disabledSubmit: false
      }
    },

    props: {
      args: {
        type: Object,
        required: true
      }
    },

    created () {
      this.init()
    },

    methods: {
      init () {
        if (this.args.userRole !== 'customer') {
          this.getUsers()
        }
      },

      async getUsers () {
        const [err, data] = await apiGetListCustomers()
        if (err) return errorMessage(err, 'Unable to access user info')
        return (this.users = data.list)
      },

      async onProjectCreate () {
        this.disabledSubmit = true
        let param = this.project

        if (this.selectedUser) {
          param = {
            customerEmail: this.selectedUser,
            customerCompanyName: this.project.customerCompanyName
          }
        }

        if (this.selectedUser && this.args.userRole === 'projectManager') {
          param = {
            customerEmail: this.selectedUser,
            name: this.project.customerCompanyName
          }
        }

        if (this.args.userRole === 'customer') {
          param = {
            customerEmail: this.args.userEmail,
            name: this.project.customerCompanyName
          }
        }

        if (param.customerPasswordPlainText) {
          param.customerPassword = sha256(param.customerPasswordPlainText)
        }

        this.$bus.$emit('loaderShow')

        const [err, data] = await apiCreateProject(this.args.userRole, param)
        this.$bus.$emit('loaderClose')
        this.$bus.$emit('modalClose')
        if (err) {
          this.disabledSubmit = false  
          return errorMessage(err, 'Unable to create project!')
        }

        return this.$router.push({name: 'project', params: {id: data.id}})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProjectCreateModal.vue?03e65bed